class ReviewService {
  // Element Content Types HTML
  static htmlTitle(review, element) {
    const title = review.title;
    if (!title) return;

    return `<div class="cf-reviews-content-type cf-reviews-title cf-merge-tag-allowed">${title}</div>`;
  }

  static htmlRating(review, element) {
    const rating = review.rating;
    if (rating === undefined || rating === null || rating === "" || isNaN(rating)) return;

    const renderStarIcon = (score) => {
      const emptyStar = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="star" class="svg-inline--fa fa-star " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" color="white"><path fill="currentColor" d="M287.9 0C297.1 0 305.5 5.25 309.5 13.52L378.1 154.8L531.4 177.5C540.4 178.8 547.8 185.1 550.7 193.7C553.5 202.4 551.2 211.9 544.8 218.2L433.6 328.4L459.9 483.9C461.4 492.9 457.7 502.1 450.2 507.4C442.8 512.7 432.1 513.4 424.9 509.1L287.9 435.9L150.1 509.1C142.9 513.4 133.1 512.7 125.6 507.4C118.2 502.1 114.5 492.9 115.1 483.9L142.2 328.4L31.11 218.2C24.65 211.9 22.36 202.4 25.2 193.7C28.03 185.1 35.5 178.8 44.49 177.5L197.7 154.8L266.3 13.52C270.4 5.249 278.7 0 287.9 0L287.9 0zM287.9 78.95L235.4 187.2C231.9 194.3 225.1 199.3 217.3 200.5L98.98 217.9L184.9 303C190.4 308.5 192.9 316.4 191.6 324.1L171.4 443.7L276.6 387.5C283.7 383.7 292.2 383.7 299.2 387.5L404.4 443.7L384.2 324.1C382.9 316.4 385.5 308.5 391 303L476.9 217.9L358.6 200.5C350.7 199.3 343.9 194.3 340.5 187.2L287.9 78.95z"></path></svg>'
      const solidStar = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" class="svg-inline--fa fa-star " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path></svg>'
      const halfStar = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star-half-stroke" class="svg-inline--fa fa-star-half-stroke " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"></path></svg>'

      const fullStars = Math.floor(score);
      const hasHalfStar = score % 1 !== 0;

      const starIcons = [];

      for (let i = 0; i < fullStars; i++) {
        starIcons.push(solidStar);
      }

      if (hasHalfStar) {
        starIcons.push(halfStar);
      }

      const remainingStars = 5 - starIcons.length;
      for (let i = 0; i < remainingStars; i++) {
        starIcons.push(emptyStar);
      }

      return starIcons.join("");
    }

    return `<div class='cf-reviews-content-type cf-reviews-rating'>${renderStarIcon(rating)}</div>`;
  }

  static htmlContent(review, element) {
    const content = review.content;
    if (!content) return;

    return `<div class="cf-reviews-content-type cf-reviews-content cf-merge-tag-allowed">${content}</div>`;
  }

  static htmlCustomerProfile(review, element) {
    const customer_title = review.customer_title;
    const customer_avatar = review.customer_avatar;
    const customer_name = review.customer_name;

    let output = '';

    if (customer_avatar && element.options["customer-profile-show-avatar"] !== "false") {
      output += `<div class="cf-reviews-customer-profile-avatar">
        <img src="${customer_avatar}" alt="Customer Avatar" loading="lazy" />
      </div>`;
    }

    if (customer_name || customer_title) {
      output += `<div class="cf-reviews-customer-column-wrapper cf-left">`;

      if (customer_name && element.options["customer-profile-show-name"] !== "false") {
        output += `<div class="cf-reviews-customer-profile-name">${customer_name}</div>`;
      }
      if (customer_title && element.options["customer-profile-show-title"] !== "false") {
        output += `<div class="cf-reviews-customer-profile-title">${customer_title}</div>`;
      }

      output += `</div>`;
    }

    return `<div class="cf-reviews-content-type cf-reviews-customer-profile">${output}</div>`;
  }

  static htmlBrandLogo(review, element) {
    const brand_logo = review.brand_logo;
    if (!brand_logo) return;

    return `<div class="cf-reviews-content-type cf-reviews-brand-logo">
      <img src="${brand_logo}" alt="Brand Logo" loading="lazy" />
    </div>`;
  }

  static htmlDate(review, element, variantOptions = {}) {
    const date = review.date;
    if (!date) return;

    const dateFormat = element.options?.['date-format']
      || variantOptions?.['reviews-date-format']
      || 'YYYY-MM-DD';
    let dateFormatted = '';
    let jsDate;

    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split('-').map(v => parseInt(v, 10));
      jsDate = new Date(year, month - 1, day);
    } else {
      jsDate = new Date(date);
    }
    if (isNaN(jsDate.getTime())) return;

    function pad(num, size = 2) {
      let s = String(num);
      while (s.length < size) s = "0" + s;
      return s;
    }

    const MONTH_NAMES_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const MONTH_NAMES_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // Perform formatting substitutions for Moment-like tokens
    dateFormatted = dateFormat
      .replace(/YYYY/g, jsDate.getFullYear())
      .replace(/MMMM/g, MONTH_NAMES_LONG[jsDate.getMonth()])
      .replace(/MMM/g, MONTH_NAMES_SHORT[jsDate.getMonth()])
      .replace(/MM/g, pad(jsDate.getMonth() + 1))
      .replace(/DD/g, pad(jsDate.getDate()))
      .replace(/D/g, jsDate.getDate())
      .replace(/M/g, jsDate.getMonth() + 1);

    return `<div class="cf-reviews-content-type cf-reviews-date">${dateFormatted}</div>`;
  }

  static htmlVideo(review, element, options = {}) {
    const videoURLFormatted = this.formatEmbedVideoLink(this.videoUrl(review));
    const videoPositioning = review?.options?.['video-positioning'] || element?.options?.['video-positioning'] || 'background';

    if (!videoURLFormatted) {
      return options.builder ? this.htmlVideoPlaceholder(videoPositioning) : '';
    }

    return `<div class="cf-reviews-content-type cf-reviews-video cf-reviews-video-${videoPositioning}">
      <iframe
        src="${videoURLFormatted}"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        loading="lazy"
        scrolling="no"
        referrerpolicy="strict-origin-when-cross-origin"
        style="pointer-events: none;"
        tabindex="-1"
      ></iframe>
    </div>`;
  }

  static htmlVideoPlaceholder(videoPositioning = 'background') {
    return `<div class="cf-reviews-content-type cf-reviews-video cf-reviews-video-${videoPositioning} cf-reviews-video-placeholder" aria-label="Video placeholder" role="img">
      <div class="cf-reviews-video-placeholder-content" style="display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 8px; width: 100%; height: 100%; min-height: 180px; background: #f3f4f6; border: 1px dashed rgba(0, 0, 0, 0.18); border-radius: 8px; box-sizing: border-box; position: relative; z-index: 2;">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="#6B7280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="12" cy="12" r="9.25" stroke="#9CA3AF" stroke-width="1.5" fill="none"></circle>
          <path d="M10 8.75C10 8.17 10.63 7.8 11.14 8.12L15.9 11.11C16.38 11.41 16.38 12.09 15.9 12.39L11.14 15.38C10.63 15.7 10 15.33 10 14.75V8.75Z"></path>
        </svg>
      </div>
    </div>`;
  }

  static htmlEmptyMessage(review, element, options = {}) {
    const message = element.options["reviews-empty-message"] || "No reviews found";
    const shouldRenderVideoPlaceholder = options.builder && this.getSortedContentTypes(element).some((contentType) => contentType.key === 'video');
    const videoPositioning = element?.options?.['video-positioning'] || 'background';

    const videoPlaceholderHtml = shouldRenderVideoPlaceholder
      ? this.htmlVideoPlaceholder(videoPositioning)
      : '';

    return `<div class="cf-row cf-outer-center cf-merge-tag-allowed cf-reviews-empty-message">
      ${videoPlaceholderHtml}
      <span>${message}</span>
    </div>`;
  }

  static htmlSource(review, element) {
    const source = review.options["source"] ? review.options["source"] : element.options["source"] ? element.options["source"] : "Source";
    const source_link = review.options["source_link"] ? review.options["source_link"] : element.options["source-link"] ? element.options["source-link"] : null;
    const source_icon_svg = element.options["source-icon-svg"];
    const show_icon = element.options["source-show-icon"];

    if (!source) return;

    let output = '<div class="cf-reviews-content-type cf-reviews-source cf-merge-tag-allowed">';
    if (show_icon !== "false" && source_icon_svg) {
      output += `<span class="cf-reviews-source-icon">${source_icon_svg}</span>`;
    }

    if (source_link) {
      const normalizedSourceLink = 'https://' + source_link.replace(/^https?:\/\//, '');
      output += `<a href="${normalizedSourceLink}" target="_blank" style="text-decoration: none !important;">${source}</a>`;
    } else {
      output += `${source}`;
    }

    output += '</div>';

    return output;
  }

  // Element Helpers

  static AVAILABLE_INTEGRATION_TYPES = [
    'Okendo',
    'Yotpo',
  ]

  static AVAILABLE_SETTING_TYPES = {
    'rating': true,
    'title': true,
    'content': true,
    'customer-profile': true,
    'brand-logo': false,
    'video': false,
    'date': false,
    'source': false,
  }

  static OKENDO_SETTING_TYPES = {
    'rating': true,
    'title': true,
    'content': true,
    'customer-profile': true,
    'brand-logo': false,
    'video': false,
    'date': false,
    'source': false,
  }

  static YOTPO_SETTING_TYPES = {
    'rating': true,
    'title': true,
    'content': true,
    'customer-profile': true,
    'brand-logo': false,
    'video': false,
    'date': true,
    'source': false,
  }

  static availableSettingTypes(element) {
    switch (element.options['reviews-source']) {
      case 'Okendo':
        return this.OKENDO_SETTING_TYPES;
      case 'Yotpo':
        return this.YOTPO_SETTING_TYPES;
      default:
        return this.AVAILABLE_SETTING_TYPES;
    }
  }

  static getSortedContentTypes(element) {
    const settingTypes = this.availableSettingTypes(element)

    return Object.keys(settingTypes)
      .map((type) => ({
        key: type,
        show: element.options[`${type}-show`],
        position: parseInt(element.options[`${type}-position`]) || 0,
      }))
      .filter((type) => {
        if (typeof type.show === "undefined" || type.show === null) {
          return settingTypes[type.key];
        }

        return type.show !== "false";
      })
      .sort((a, b) => a.position - b.position);
  }

  static ReviewRenderer = class {
    constructor(review, element, options = {}, variantOptions = {}) {
      this.review = review;
      this.element = element;
      this.builder = options.builder || false;
      this.variantOptions = variantOptions || {};
      this.sortedContentTypes = ReviewService.getSortedContentTypes(element);
      this.videoPositioning = review.options?.['video-positioning'] || element?.options?.['video-positioning'] || 'background';
      this.videoContent = this.sortedContentTypes.find(ct => ct.key === 'video');
      this.hasVideoSlot = !!this.videoContent;
      this.hasVideo = !!ReviewService.formatEmbedVideoLink(ReviewService.videoUrl(review));
      this.otherContent = this.videoPositioning === 'background' || ['left', 'right'].includes(this.videoPositioning)
        ? this.sortedContentTypes.filter(ct => ct.key !== 'video')
        : this.sortedContentTypes;
    }

    generateContentHtml(contentTypes) {
      return contentTypes.map((contentType) => {
        const methodName = `html${ReviewService.constantizeString(contentType.key)}`;
        if (!ReviewService[methodName]) return '';
        if (methodName === 'htmlVideo' || methodName === 'htmlEmptyMessage') {
          return ReviewService[methodName](this.review, this.element, { builder: this.builder });
        }
        return ReviewService[methodName](this.review, this.element);
      }).filter(html => html).join('');
    }

    getContainerClasses() {
      const baseClass = 'cf-reviews-content-box';

      if (this.isBackgroundVideo()) {
        return `${baseClass} cf-reviews-with-background-video`;
      } else if (this.isPositionedVideo()) {
        return `${baseClass} cf-reviews-with-positioned-video`;
      }

      return baseClass;
    }

    isBackgroundVideo() {
      return this.hasVideoSlot && this.videoPositioning === 'background';
    }

    isPositionedVideo() {
      return this.hasVideoSlot && ['left', 'right'].includes(this.videoPositioning);
    }

    renderBackgroundVideo() {
      if (!this.isBackgroundVideo()) return '';
      return `<div class="cf-reviews-background-video-overlay">${this.generateContentHtml([this.videoContent])}</div>`;
    }

    renderMainContent() {
      if (this.isBackgroundVideo()) {
        return this.generateContentHtml(this.otherContent);
      } else if (this.isPositionedVideo()) {
        return this.renderPositionedVideoLayout();
      } else {
        return this.generateContentHtml(this.sortedContentTypes);
      }
    }

    renderPositionedVideoLayout() {
      const videoHtml = this.generateContentHtml([this.videoContent]);
      const textContentHtml = this.generateContentHtml(this.otherContent);
      const videoContainer = videoHtml
        ? `<div class="cf-reviews-video-container cf-reviews-video-${this.videoPositioning}">${videoHtml}</div>`
        : '';

      if (this.videoPositioning === 'left') {
        return `${videoContainer}<div class="cf-reviews-text-content">${textContentHtml}</div>`;
      } else if (this.videoPositioning === 'right') {
        return `<div class="cf-reviews-text-content">${textContentHtml}</div>${videoContainer}`;
      }
    }

    renderHtml() {
      const containerClasses = this.getContainerClasses();
      const backgroundVideoHtml = this.renderBackgroundVideo();
      const mainContent = this.renderMainContent();

      let contentWrapper;
      if (this.isPositionedVideo()) {
        contentWrapper = `<div class="cf-reviews-main-content cf-reviews-video-layout-${this.videoPositioning}">${mainContent}</div>`;
      } else {
        contentWrapper = `<div class="cf-reviews-content-wrapper">${mainContent}</div>`;
      }

      return `<div class="${containerClasses}" data-review-id="${this.review.id || ''}">
        ${backgroundVideoHtml}${contentWrapper}
      </div>`;
    }

    // For React component usage - returns structured data instead of HTML
    renderData() {
      return {
        containerClasses: this.getContainerClasses(),
        isBackgroundVideo: this.isBackgroundVideo(),
        isPositionedVideo: this.isPositionedVideo(),
        backgroundVideoHtml: this.renderBackgroundVideo(),
        mainContentHtml: this.renderMainContent(),
        videoPositioning: this.videoPositioning,
        hasVideo: this.hasVideo,
        hasVideoSlot: this.hasVideoSlot
      };
    }
  }

  static videoUrl(review) {
    return review?.video || review?.video_url || "";
  }

  static htmlReviewContentBox(review, element, options = {}) {
    const renderer = new this.ReviewRenderer(review, element, options);
  }

  static htmlReviewContentBox(review, element, variantOptions = {}) {
    const renderer = new this.ReviewRenderer(review, element, variantOptions);
    return renderer.renderHtml();
  }

  static constantizeString(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  }

  static embedYoutubeLink = (videoUrl) => {
    // Accept: youtu.be/, youtube.com/watch?v=, /embed/, /v/, /u/w/, /shorts/
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?\/]*).*/;
    let match = videoUrl.match(regExp);
    let youtubeId = match && match[2] && match[2].length === 11 ? match[2] : null;

    if (!youtubeId) {
      const shortsMatch = videoUrl.match(/(?:youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/);
      youtubeId = shortsMatch && shortsMatch[1] ? shortsMatch[1] : null;
    }

    if (!youtubeId) {
      const beMatch = videoUrl.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
      youtubeId = beMatch && beMatch[1] ? beMatch[1] : null;
    }

    if (!youtubeId) return "";

    return `https://www.youtube.com/embed/${youtubeId}?autoplay=1&loop=1&mute=1&playlist=${youtubeId}`;
  };

  static embedVimeoLink = (videoUrl) => {
    const regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
    const match = videoUrl.match(regExp);
    const vimeoId = match[1];

    return `https://player.vimeo.com/video/${vimeoId}?autoplay=1&loop=1&color=ED8374&title=0&byline=0&portrait=0&badge=0`;
  };

  static embedWistiaLink = (videoUrl) => {
    const regExp = /(?:wistia)\..*(?:medias\/|embed\/)([^#&? ]*)/i;
    const match = videoUrl.match(regExp);
    const wistiaId = match[1];

    return `https://fast.wistia.net/embed/iframe/${wistiaId}`;
  };

  static formatEmbedVideoLink = (videoUrl) => {
    if (!videoUrl) return "";

    let formattedVideoUrl = "";

    switch (true) {
      case videoUrl.includes("youtube") || videoUrl.includes("youtu.be"):
        formattedVideoUrl = this.embedYoutubeLink(videoUrl);
        break;
      case videoUrl.includes("vimeo"):
        formattedVideoUrl = this.embedVimeoLink(videoUrl);
        break;
      case videoUrl.includes("wistia"):
        formattedVideoUrl = this.embedWistiaLink(videoUrl);
        break;
      default:
        formattedVideoUrl = videoUrl;
        break;
    }

    return formattedVideoUrl;
  }

  static createCollage(reviewsList, numberPerRow) {
    const columns = {};
    for (let c = 0; c < numberPerRow; c++) {
      columns[c] = [];
    }

    for (let i = 0; i < reviewsList.length; i++) {
      const col = i % numberPerRow;
      columns[col].push(reviewsList[i]);
    }
    return columns;
  }

  // Filters

  static apiQuery(objectToUse) {
    let queries = [];

    if ([undefined, "", "selection"].includes(objectToUse.options["reviews-filter-type"])) {
      queries.push(`ids=${objectToUse.options['reviews-ids']}`);
    } else if (objectToUse.options["reviews-filter-type"] == "filter") {
      const activeFilters = objectToUse.options['reviews-filters'] || [];
      const reviewsFiltersKeyword = objectToUse.options['reviews-filters-keyword'] || '';
      const reviewsFiltersRatingCondition = objectToUse.options['reviews-filters-rating-condition'] || 'greater_than';
      const reviewsFiltersRatingValue = objectToUse.options['reviews-filters-rating-value'] || '';
      const reviewsFiltersDateCondition = objectToUse.options['reviews-filters-date-condition'] || 'greater_than';
      const reviewsFiltersDateValue = objectToUse.options['reviews-filters-date-value'] || '';
      const reviewsFiltersHasVideo = objectToUse.options['reviews-filters-has-video'] !== 'false';

      if (activeFilters.includes('keyword') && reviewsFiltersKeyword && reviewsFiltersKeyword.trim() !== '') {
        queries.push(`keywords=${reviewsFiltersKeyword}`);
      }

      if (activeFilters.includes('rating') && reviewsFiltersRatingValue && reviewsFiltersRatingValue.trim() !== '') {
        if (reviewsFiltersRatingCondition == 'greater_than') {
          queries.push(`rating_greater_than=${reviewsFiltersRatingValue}`);
        } else if (reviewsFiltersRatingCondition == 'less_than') {
          queries.push(`rating_less_than=${reviewsFiltersRatingValue}`);
        } else if (reviewsFiltersRatingCondition == 'equal_to') {
          queries.push(`rating_equal_to=${reviewsFiltersRatingValue}`);
        }
      }

      if (activeFilters.includes('video') && reviewsFiltersHasVideo == true) {
        queries.push(`has_video=${reviewsFiltersHasVideo}`);
      }

      if (activeFilters.includes('date') && reviewsFiltersDateValue && reviewsFiltersDateValue.trim() !== '') {
        if (reviewsFiltersDateCondition == 'greater_than') {
          queries.push(`date_greater_than=${reviewsFiltersDateValue}`);
        } else if (reviewsFiltersDateCondition == 'less_than') {
          queries.push(`date_less_than=${reviewsFiltersDateValue}`);
        } else if (reviewsFiltersDateCondition == 'equal_to') {
          queries.push(`date_equal_to=${reviewsFiltersDateValue}`);
        }
      }

      queries.push(`limit=50`);
    }

    return queries.join('&');
  }

  static clientFilteredReviews(allReviews, objectToUse) {
    let outputReviews = allReviews;

    if ([undefined, "", "selection"].includes(objectToUse.options["reviews-filter-type"])) {
      const reviewsIds = objectToUse.options["reviews-ids"]?.split(",")?.map(id => id.trim()).filter(id => id);

      outputReviews = reviewsIds && reviewsIds.length > 0
        ? reviewsIds
            .map(id => outputReviews.find(review => review.id.toString() === id))
            .filter(review => review)
        : [];
    } else if (objectToUse.options["reviews-filter-type"] == "filter") {
      outputReviews = ReviewService.filteredReviews(outputReviews, objectToUse);
    }

    return ReviewService.sortedReviews(outputReviews, objectToUse);
  }

  static filteredReviews(reviews, element) {
    const reviewsFiltersKeyword = element.options['reviews-filters-keyword'] || '';
    const reviewsFiltersRatingCondition = element.options['reviews-filters-rating-condition'] || 'greater_than';
    const reviewsFiltersRatingValue = element.options['reviews-filters-rating-value'] || '';
    const reviewsFiltersDateCondition = element.options['reviews-filters-date-condition'] || 'greater_than';
    const reviewsFiltersDateValue = element.options['reviews-filters-date-value'] || '';
    const reviewsFiltersHasVideo = element.options['reviews-filters-has-video'] !== 'false';

    const reviewsFiltersRatingGreaterThan = reviewsFiltersRatingCondition == 'greater_than';
    const reviewsFiltersRatingLessThan = reviewsFiltersRatingCondition == 'less_than';
    const reviewsFiltersRatingEqualTo = reviewsFiltersRatingCondition == 'equal_to';

    let output = reviews.filter((review) => {
      // Get the active filters
      const activeFilters = element.options['reviews-filters'] || [];

      // Keyword filter - supports comma-separated values
      if (activeFilters.includes('keyword') && reviewsFiltersKeyword && reviewsFiltersKeyword.trim() !== '') {
        const keywords = reviewsFiltersKeyword
          .split(',')
          .map(k => k.trim().toLowerCase())
          .filter(k => k !== '');

        const reviewContent = [
          review?.title?.toLowerCase() || '',
          review?.content?.toLowerCase() || '',
          review?.customer_name?.toLowerCase() || '',
          review?.customer_title?.toLowerCase() || ''
        ].join(' ');

        const matchesKeyword = keywords.some(keyword => reviewContent.includes(keyword));

        if (!matchesKeyword) return false;
      }

      // Rating filter - only apply if rating value is present
      if (activeFilters.includes('rating') && reviewsFiltersRatingValue && reviewsFiltersRatingValue.trim() !== '') {
        const reviewRating = parseFloat(review.rating);
        const filterRating = parseFloat(reviewsFiltersRatingValue);

        if (isNaN(reviewRating)) return false;
        if (reviewsFiltersRatingGreaterThan && reviewRating < filterRating) return false;
        if (reviewsFiltersRatingLessThan && reviewRating > filterRating) return false;
        if (reviewsFiltersRatingEqualTo && reviewRating !== filterRating) return false;
      }

      // Video filter
      if (activeFilters.includes('video') && reviewsFiltersHasVideo == true) {
        const hasVideo = review.video_url || review.has_video;
        if (!hasVideo) return false;
      }

      // Date filter - only apply if date value is present
      if (activeFilters.includes('date') && reviewsFiltersDateValue && reviewsFiltersDateValue.trim() !== '') {
        const reviewDate = new Date(review.date || review.created_at);
        const filterDate = new Date(reviewsFiltersDateValue);

        if (reviewsFiltersDateCondition === 'greater_than' && reviewDate <= filterDate) return false;
        if (reviewsFiltersDateCondition === 'less_than' && reviewDate >= filterDate) return false;
        if (reviewsFiltersDateCondition === 'equal_to') {
          const reviewDateStr = reviewDate.toDateString();
          const filterDateStr = filterDate.toDateString();
          if (reviewDateStr !== filterDateStr) return false;
        }
      }

      return true;
    });

    // Apply maximum count limit (defaults to 6)
    const maxCount = element.options['reviews-max-count'];
    const limit = maxCount && parseInt(maxCount) > 0 ? parseInt(maxCount) : 6;
    output = output.slice(0, limit);

    return output;
  }

  static sortedReviews(reviews, element) {
    const reviewsSort = element.options["reviews-sorting"];
    const reviewsSortingOperator = element.options["reviews-sorting-operator"] || "asc";

    let output = reviews;

    if (reviewsSort == "position") {
      output.sort((a, b) => a.position - b.position);
    } else if (!reviewsSort || reviewsSort == "date") {
      if (reviewsSortingOperator == "asc") {
        output.sort((a, b) => new Date(a.date) - new Date(b.date));
      } else {
        output.sort((a, b) => new Date(b.date) - new Date(a.date));
      }
    } else if (reviewsSort == "rating") {
      if (reviewsSortingOperator == "asc") {
        output.sort((a, b) => {
          const aRating = a.rating;
          const bRating = b.rating;
          return aRating - bRating;
        });
      } else {
        output.sort((a, b) => {
          const aRating = a.rating;
          const bRating = b.rating;
          return bRating - aRating;
        });
      }
    } else if (reviewsSort == "title") {
      if (reviewsSortingOperator == "asc") {
        output.sort((a, b) => a.title.localeCompare(b.title));
      } else {
        output.sort((a, b) => b.title.localeCompare(a.title));
      }
    }

    return output;
  }
}

if (typeof globalThis !== 'undefined') {
  globalThis.ReviewService = ReviewService;
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ReviewService = ReviewService;
}
